module.exports = __webpack_public_path__ + "img/logo_navbar.e34d93ec.png";